module.exports = __webpack_public_path__ + "static/media/eurodrive-col-3.1bf3bed3.png";